export const NOTIFICATIONS = 'NOTIFICATIONS';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
export const TODAY_NOTIFICATIONS = 'TODAY_NOTIFICATIONS';
export const TODAY_NOTIFICATIONS_ERROR = 'TODAY_NOTIFICATIONS_ERROR';
export const EARLIER_NOTIFICATIONS = 'EARLIER_NOTIFICATIONS';
export const EARLIER_NOTIFICATIONS_ERROR = 'EARLIER_NOTIFICATIONS_ERROR';
export const UN_READ_NOTIFICATIONS_COUNT_PARCEL = 'UN_READ_NOTIFICATIONS_COUNT_PARCEL';
export const UN_READ_NOTIFICATIONS_COUNT_AMENITIES = 'UN_READ_NOTIFICATIONS_COUNT_AMENITIES';
export const UN_READ_NOTIFICATIONS_COUNT_MAINTENANCE = 'UN_READ_NOTIFICATIONS_COUNT_MAINTENANCE';
export const NOTIFICATION_RECEIVED_ARRAY = 'NOTIFICATION_RECEIVED_ARRAY';